var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { getChatLinkByType, getDriveLinkByType } from '@web/utility';
import { formatEventsLogEventTitle } from '@web/utility/eventsLogUtils';
import { ApplicationEnum } from '@workalizer/shared';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
function EventsTableTitleEvent(_a) {
    var _b, _c, _d, _e;
    var event = _a.event;
    var t = useTranslation().t;
    var linkClassNames = 'overflow-hidden inline-block overflow-ellipsis w-full text-indigo-500 font-medium underline decoration-dashed underline-offset-2 hover:no-underline';
    var textClassNames = 'overflow-hidden inline-block overflow-ellipsis w-full text-gray-900 font-medium';
    var formattedEventTitle = formatEventsLogEventTitle(event, t);
    switch (event.applicationName) {
        case ApplicationEnum.DRIVE:
            if ((_b = event.documentEvent) === null || _b === void 0 ? void 0 : _b.document.slugId)
                return (_jsx(Link, __assign({ to: getDriveLinkByType((_c = event.documentEvent) === null || _c === void 0 ? void 0 : _c.document.type, (_d = event.documentEvent) === null || _d === void 0 ? void 0 : _d.document.slugId), target: "_blank", className: linkClassNames }, { children: formattedEventTitle })));
            return _jsx("span", __assign({ className: textClassNames }, { children: formattedEventTitle }));
        case ApplicationEnum.MEET:
            return _jsx("span", __assign({ className: textClassNames }, { children: formattedEventTitle }));
        case ApplicationEnum.GMAIL:
            return _jsx("span", __assign({ className: textClassNames }, { children: formattedEventTitle }));
        case ApplicationEnum.CHAT: {
            var room = (_e = event.chatEvent) === null || _e === void 0 ? void 0 : _e.room;
            if (room === null || room === void 0 ? void 0 : room.slugId) {
                return (_jsx(Link, __assign({ to: getChatLinkByType(room.type, room.slugId), className: linkClassNames }, { children: formattedEventTitle })));
            }
            return _jsx("span", __assign({ className: textClassNames }, { children: formattedEventTitle }));
        }
        default:
            return _jsx("span", __assign({ className: textClassNames }, { children: formattedEventTitle }));
    }
}
export default EventsTableTitleEvent;
